import React, { useState, useEffect, useRef } from "react";
import {GoogleMap, useLoadScript, Marker, MarkerClusterer, StandaloneSearchBox} from "@react-google-maps/api"
import { AppCTX } from '../data/AppContext';
import AreaManager from './AreaManager'
import MyLocationIcon from '@mui/icons-material/MyLocation';
import IconButton from '@mui/material/IconButton';
import AddHomeIcon from '@mui/icons-material/AddHome';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Stack from '@mui/material/Stack';
import Slide from '@mui/material/Slide';
import MyLocationMarker from "./MyLocationMarker";

const config = {
  'googleMapsApiKey': process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  libraries: ['drawing', 'places']
}

function DoorHopperMap({ prospects, newProspect, setNewProspect, leadType}) {
  const { map, setMap, appointments, setLeadType, setOpenAddProspect, setGetPropertyDetails, setIsMapLoaded } = React.useContext(AppCTX);
  const { isLoaded, loadError } = useLoadScript({
    ...config,
    loading: 'async'
  });
  const [zoomLevel, setZoomLevel] = useState(20)
  const [center, setCenter] = useState(null)
  const [areaManager, setAreaManager] = useState(false)
  const [teamData, setTeamData] = useState(null)
  const [triggerSaveAreaAssignment, setTriggerSaveAreaAssignment] = useState(false)
  const [locations, setLocations] = useState([])

  useEffect(()=>{
    updatelocations()
  },[prospects, appointments])

  useEffect(() => {
    if (isLoaded && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setCenter({ lat: latitude, lng: longitude });
        },
        () => {
          console.error("Error getting current position");
        }
      );
    }
  },[isLoaded])

  const updatelocations = () => {
    let updatedLocations = [...prospects, ...appointments]
    setLocations(updatedLocations)
  }

  const handleMapClick = (e) => {
    if(leadType === 0){
      const newMarker = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng()
      }
      const update = {...newProspect}
      update.coords = newMarker
      console.log('map clicked', update)
      setNewProspect(update);
    }
  }

  const handleZoomChange = () => {
    if(map){
      const newZoom = map.getZoom();
      setZoomLevel(newZoom);
    }
  }

  const scrollLeadIntoView = (lead) => {
    if(lead.appointmentStart!=null){
      setLeadType(1)
      // document.getElementById(`${lead.owners[0].name}-${lead.owners[0].number}`).scrollIntoView({ behavior: "smooth"})
    }else{
      document.getElementById(`${lead.owners[0].name}-${lead.owners[0].number}`).scrollIntoView({ behavior: "smooth"})
    }

  }

  const onLoad = React.useCallback(
    async function onLoad (mapInstance) {
      setMap(mapInstance)
      setIsMapLoaded(true);
    },[]
  )

  const findMyLocationHandler = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          map.panTo(pos);
          map.setZoom(20)
        },
        (error) => {
          console.log(error)
        },
      );
    }
  }

  const clustererOptions = {
    maxZoom: 16,
    imagePath:
      "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m", // so you must have m1.png, m2.png, m3.png, m4.png, m5.png and m6.png in that folder
  };

  
  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading...</div>;
  else {
    return(
      <GoogleMap
        zoom={20}
        center={center}
        mapContainerClassName="google-map"
        onClick={areaManager?null:handleMapClick}
        onLoad={onLoad}
        onZoomChanged={handleZoomChange}
        getCurrentPosition
        options={{
          // mapId:'1a4388086030157b',
          mapTypeId:'hybrid',
          styles: [
            {
              featureType: 'poi',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            }
          ],
          zoomControl: false,
          mapTypeControl: false,
          streetViewControl: false,
          gestureHandling: "greedy",
          disableDefaultUI: true
        }}
      >
        <MyLocationMarker mapInstance={map}/>
        <MarkerClusterer options={clustererOptions}>
          {(clusterer) =>
            locations.map((lead) => (
              <Marker
                onClick={()=>scrollLeadIntoView(lead)}
                key={`${lead.coords.lat}-${lead.coords.lng}`}
                position={lead.coords}
                clusterer={clusterer}

              />
            ))
            .concat(
              newProspect.coords && (
                <Marker
                  key={`${newProspect.coords.lat}-${newProspect.coords.lng}`}
                  position={newProspect.coords}
                  clusterer={clusterer}
                />
              )
            )
          }
        </MarkerClusterer>
        <AreaManager
          setAreaManager={setAreaManager}
          areaManager={areaManager}
          triggerSaveAreaAssignment={triggerSaveAreaAssignment}
          setTriggerSaveAreaAssignment={setTriggerSaveAreaAssignment}
          teamData={teamData}
          setTeamData={setTeamData}
          zoomLevel={zoomLevel}
        />
        <Stack spacing={2} id="map-right-controls">
          <Slide direction="left" in={newProspect.coords!=false} mountOnEnter unmountOnExit>
            <IconButton onClick={()=>setGetPropertyDetails(true)}  id="get-insights-btn" aria-label="delete" size="large">
              <HelpOutlineIcon />
            </IconButton>
          </Slide>
          <Slide direction="left" in={newProspect.coords!=false} mountOnEnter unmountOnExit>
            <IconButton  id="add-prospect-btn" onClick={()=>setOpenAddProspect(true)} aria-label="delete" size="large">
              <AddHomeIcon />
            </IconButton>
          </Slide>
          <IconButton id="my-location-btn" onClick={findMyLocationHandler} aria-label="delete" size="large">
            <MyLocationIcon />
          </IconButton>
        </Stack>
      </GoogleMap>
    )
  };
}

export default DoorHopperMap;
